import { FC, ReactElement, useState, useRef, useMemo } from 'react';

import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';

import { RecentResultsItemType } from '../../../api/recentResults';
import { numberFormatter } from '../../../config/utils';
import { useHighflyerGameStateSlice } from '../../../store/slices/highflyerGame/selectors';
import { useRecentResultDetailStateSlice } from '../../../store/slices/recentResultDetail/selectors';
import stylesSingleButton from '../../recentResults/singleResult/SingleResult.module.css';
import TimerButton from '../timer/TimerButton';

import styles from './ModalButton.module.css';

interface ModalButtonProp {
  index: number;
  setDirection: React.Dispatch<React.SetStateAction<string>>;
}

enum CssType {
  btnValue1 = 2,
  btnValue2 = 5,
  btnValue3 = 10,
  btnValue4 = 100,
  btnValue5 = Infinity,
}

export const ModalButton: FC<ModalButtonProp> = ({ index, setDirection }): ReactElement => {
  const cssType = useRef('');
  const locale = useSettingsSlice.currentLanguage();
  const [displayValue, setDisplayValue] = useState(0);

  const formatedNumber = useMemo(() => {
    return numberFormatter(Number(displayValue), locale);
  }, [locale, displayValue]);

  const formattedMultiplier = formatedNumber;
  const currentModalData = useRecentResultDetailStateSlice.getHashModalData();
  const clickedTab = currentModalData.clickedTab;
  const totalResults: number = useHighflyerGameStateSlice.recentResultsCount();
  const resultMultiplier = useRecentResultDetailStateSlice.getResultMultiplier();

  let details: RecentResultsItemType | undefined;

  if (clickedTab !== 'footer') {
    setDisplayValue(resultMultiplier);
  } else if (index >= 0 && clickedTab === 'footer') {
    if (index < totalResults) {
      details = useHighflyerGameStateSlice.recentResults()?.history[index];
    }
    if (details) {
      setDisplayValue(details.gameResult);
    }
  }

  for (const key in CssType) {
    if (displayValue <= Number(CssType[key])) {
      cssType.current = stylesSingleButton[key as keyof typeof CssType];
      break;
    }
  }

  return (
    <div className={styles.modalButton}>
      {index >= 0 && (
        <div
          className={`${stylesSingleButton.modalButtonSingle} ${stylesSingleButton.singleResult} ${cssType.current}`}
        >
          {formattedMultiplier}x
        </div>
      )}
      {index === -1 && <TimerButton />}
    </div>
  );
};
